import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { cloudinaryAsset } from '../config/media';

const clientGroups = [
  {
    key: 'commercial',
    clients: [
      ['AXE', 'AXE-logо.png'], ['Arcor', 'Arcor_logo.svg.webp'], ['Baly', 'baly.png'],
      ['Bimbo', 'Bimbo_logo.png'], ['Bionatural', 'bionatural.png'], ['Coca-Cola', 'Coca-Cola-logo.png'],
      ['Car One', 'carone.png'], ['Decathlon', 'decathlon.png'], ['Devoto', 'Devoto_Logo.svg'],
      ['Dove', 'Dove_logo.png'], ['Droguería Montevideo', 'Drogueria Montevideo.png'], ['Dr. Selby', 'dr.selby.png'],
      ['Duracell', 'Duracell-logo.png'], ['Equilibrio', 'equilibrio.png'], ['Farmashop', 'farmashop.png'],
      ['Fresh Up', 'FreshUp.png'], ['Gillette', 'Gillette-Logo.png'], ['Grido', 'grido_nuevo.png'],
      ['H. Valdi', 'H.Valdi.png'], ['Hellmann\'s', 'Hellmanns-Logo.png'], ['Hikvision', 'hikvision-logo.png'],
      ['Itaú', 'Itaú_Unibanco_logo_2023.svg.webp'], ['Kinko', 'kinko.png'], ['Knorr', 'Knorr_Logo_2020.svg'],
      ["L'Oréal", 'LOreal-logo.png'], ['Life Cinemas', 'Logo-Life-Cinemas.svg'], ['Listerine', 'Listerine-Logo.wine.png'],
      ['Marbella', 'marbella.svg'], ['Megalabs', 'megalabs.png'], ['Natal', 'natal.svg'],
      ['Nestlé', 'Nestle-Logо.png'], ['Nestlé', 'Nestle_textlogo_blue.svg.webp'], ['Pro Plan', 'proplan.png'],
      ['Redpagos', 'redpagos.png'], ['Renner', 'renner.png'], ['Royal Canin', 'Royal Canin.png'],
      ['Sadenir', 'sadenir_logo.png'], ['Salus', 'logo-Salus.svg'], ['Samsung', 'Samsung-Logo.png'],
      ['Sebamar', 'sebamar.png'], ['Sika', 'Sika_Logo.png'], ['Smart Fit', 'Smart_Fit_logo.svg.webp'],
      ['TaTa', 'tata.svg'], ['TRESemmé', 'Tresemme_new_logo.png'], ['Unilever', 'Unilever-Logo-1.png'],
      ['Vivion', 'vivion.png'], ['Würth', 'wurth.png']
    ]
  },
  {
    key: 'institutions',
    clients: [
      ['Club Nacional de Football', 'Club_Nacional_de_Football.png'],
      ['Estadio Centenario', 'centenarii.jpg'],
      ['Juana', 'logo-juana-full.png'],
      ['Cudesa', 'logo_cudesa.png']
    ]
  },
  {
    key: 'government',
    clients: [
      ['ASSE', 'asse.jpg'], ['Banco República', 'Logo-BROU.svg'],
      ['Intendencia de Canelones', 'gobierno de canelones.png'], ['Intendencia de Maldonado', 'int  maldonado.png'],
      ['Intendencia de Montevideo', 'Intendencia_montevideo_logo.png'], ['INAC', 'inac.png'],
      ['UTE', 'Logo-UTE.svg']
    ]
  }
];

const Clientes = () => {
  const { t } = useTranslation();

  return (
  <main id="clientes-page" className="clients-page">
    <section className="clients-hero">
      <Container>
        <p className="clients-eyebrow">{t('clientsPage.eyebrow')}</p>
        <h1>{t('clientsPage.title')}</h1>
        <p>{t('clientsPage.description')}</p>
      </Container>
    </section>

    <section className="clients-content">
      <Container>
        {clientGroups.map(({ key, clients }) => (
          <section className="client-group" key={key} aria-labelledby={`group-${key}`}>
            <h2 id={`group-${key}`}>{t(`clientsPage.groups.${key}`)}</h2>
            <div className="clients-logo-grid">
              {clients.map(([name, filename]) => (
                <article className="clients-logo-card" key={filename}>
                  <img src={cloudinaryAsset(`/clientes/${filename}`)} alt={t('clientsPage.logoAlt', { name })} loading="lazy" />
                </article>
              ))}
            </div>
          </section>
        ))}
      </Container>
    </section>
  </main>
  );
};

export default Clientes;
